module.exports = __webpack_public_path__ + "static/media/IlichRealty.bb9617d8.mp4";